<template>
  <div class="page-wrap" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form
          ref="formRef"
          :model="initiative"
          :rules="rules"
          label-position="top"
          hide-required-asterisk
        >
          <el-row :gutter="10">
            <el-col
              v-if="!isModerator"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item label="Tashabbus tavsifi" prop="description">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="initiative.description"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="!isModerator"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item label="Moderator kommenti" prop="moderator_comment">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="initiative.moderator_comment"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="!isModerator"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item label="So'ralgan mablag'" prop="requested_amount">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="initiative.requested_amount"
                  v-money="money"
                  type="text"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="!isModerator"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item label="Tasdiqlangan mablag'" prop="granted_amount">
                <el-input
                  size="large"
                  class="form-input"
                  v-model="initiative.granted_amount"
                  v-money="money"
                  type="text"
                />
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tashabbus kategoriyasi" prop="category_id">
                <el-select
                  @change="changeCategory"
                  v-model="initiative.category_id"
                  style="width: 100%"
                >
                  <el-option
                    v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                    :label="category.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!isModerator"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item label="Viloyat" prop="region_id">
                <el-select
                  v-model="initiative.region_id"
                  style="width: 100%"
                  @change="onChangeRegion"
                >
                  <el-option
                    v-for="region in regions"
                    :key="region.id"
                    :value="region.id"
                    :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!isModerator"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                  v-model="initiative.district_id"
                  style="width: 100%"
                  @change="onChangeDistrict"
                >
                  <el-option
                    v-for="district in districts"
                    :key="district.id"
                    :value="district.id"
                    :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Mahalla" prop="quarter_id">
                <el-select v-model="initiative.quarter_id" style="width: 100%">
                  <el-option
                    v-for="quarter in quarters"
                    :key="quarter.id"
                    :value="quarter.id"
                    :label="quarter.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!isModerator"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item label="Bosqich" prop="stage">
                <el-select v-model="initiative.stage" style="width: 100%">
                  <el-option
                    v-for="stage in stages"
                    :key="stage"
                    :value="stage"
                    :label="stage"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item
                label="Tashkilot nomi"
                prop="organization_id"
                v-if="showOrganizationField"
              >
                <el-select
                  v-model="initiative.organization_id"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in organizationList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              v-if="!isModerator"
            >
              <el-form-item label="Tashkilot turi" prop="type">
                <el-select v-model="initiative.type" style="width: 100%">
                  <el-option
                    v-for="item in types"
                    :key="item.id"
                    :value="item.id"
                    :label="item.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                label="Xarid qilinadigan tovarlar reestrini yuklang"
                prop="purchased_goods_file"
                v-if="initiative.type === 'EQUIPMENT'"
                style="margin-bottom: 35px"
              >
                <el-upload
                  ref="uploadRef"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHeader"
                  v-model:file-list="purchased_goods_files"
                  :multiple="false"
                  accept="application/pdf"
                  :limit="1"
                  :on-success="onSuccessUpload"
                  :on-error="onErrorUpload"
                >
                  <template #trigger>
                    <el-button style="width: 100%" type="primary">
                      Харид килинадиган товарлар реестри
                    </el-button>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => $router.go(-1)"
                  >Orqaga</el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "InitiativeForm",
  data() {
    function amountValidate(rule, value, callback) {
      if (value === "0") {
        callback(new Error("Qiymat 0 dan katta bo'lishi kerak"));
      } else if (parseFloat(value.replace(/\s/g, "")) > 1360000000) {
        callback(new Error("Qiymat 1 360 000 000 dan kichik bo'lishi kerak"));
      } else {
        callback();
      }
    }

    function grantedAmountValidate(rule, value, callback) {
      if (parseFloat(value.replace(/\s/g, "")) > 1360000000) {
        callback(new Error("Qiymat 1 360 000 000 dan kichik bo'lishi kerak"));
      } else {
        callback();
      }
    }

    return {
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      purchased_goods_files: [],
      loading: false,
      initiativeId: null,
      isModerator: false,
      initiative: {
        description: null,
        requested_amount: null,
        granted_amount: null,
        moderator_comment: null,
        region_id: null,
        organization_id: null,
        district_id: null,
        quarter_id: null,
        category_id: null,
        stage: null,
        type: null,
        purchased_goods_file: null,
      },
      organizationList: [],
      showOrganizationField: false,
      types: [
        { id: "CONSTRUCTION", title: "Qurilish" },
        { id: "EQUIPMENT", title: "Xarid qilish" },
      ],
      districts: [],
      regions: [],
      quarters: [],
      categories: [],
      rules: {
        description: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        region_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        district_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        quarter_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        category_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        type: [
          { required: false, message: "Majburiy maydon", trigger: "change" },
        ],
        purchased_goods_file: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        organization_id: [
          {
            required: true,
            message: "Majburiy maydon",
            trigger: "change",
          },
        ],
        granted_amount: [{ validator: grantedAmountValidate, trigger: "blur" }],
        requested_amount: [{ validator: amountValidate, trigger: "blur" }],
      },
      stages: ["INITIAL", "PASSED", "NOT_PASSED"],
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 0,
      },
    };
  },
  watch: {
    "initiative.district_id": "checkInitiativeInfo",
    "initiative.category_id": "checkInitiativeInfo",
    categories: "checkInitiativeInfo",
  },

  methods: {
    onSuccessUpload(res) {
      console.log(res);
      this.initiative.purchased_goods_file = res.hashId;
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }
      this.initiative.organization_id = null;
      ElNotification.error({
        message:
          JSON.parse(error?.message)?.message ||
          "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },
    checkInitiativeInfo() {
      if (
        this.initiative.district_id &&
        this.initiative.category_id &&
        this.categories.length
      ) {
        console.log(
          this.initiative.district_id,
          this.initiative.category_id,
          "check info"
        );
        this.getOrganizations(
          this.initiative.district_id,
          this.initiative.category_id
        );
      }
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;

          const formData = {
            ...this.initiative,
            granted_amount: parseFloat(
              this.initiative.granted_amount.replace(/\s/g, "")
            ),
            requested_amount: parseFloat(
              this.initiative.requested_amount.replace(/\s/g, "")
            ),
          };

          if (!this.isModerator) {
            this.$http
              .patch(
                `api/v1/initiatives/${this.initiative.public_id}`,
                formData
              )
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({ response }) => {
                ElNotification({
                  title: "Xatolik",
                  message: response.data.message,
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            this.$http
              .put(
                `api/v1/moderators/initiatives/${this.initiative.public_id}`,
                formData
              )
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({ response }) => {
                ElNotification({
                  title: "Xatolik",
                  message: response.data.message,
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    changeCategory(e) {
      console.log(e);
      this.getOrganizations(this.initiative.district_id, e);
    },
    getOrganizations(district_id, category_id) {
      const selectedOption = this.categories.find(
        (option) => option.id === category_id
      );
      this.showOrganizationField = !!selectedOption?.organization_type;

      if (!this.showOrganizationField) {
        this.initiative.organization_id = null;
      }

      if (this.showOrganizationField) {
        this.loading = true;
        this.$http
          .get(
            `api/v1/organizations?district_id=${district_id}&&organization_type=${selectedOption.organization_type}`
          )
          .then((res) => {
            this.organizationList = res.data?.organizations;
          })
          .catch((error) => {
            console.log(error);
            ElNotification.error({
              message:
                error.response.data.message ||
                "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    onChangeRegion() {
      this.districts = [];
      this.initiative.district_id = null;
      this.quarters = [];
      this.initiative.quarter_id = null;
      this.getDistricts();
    },
    onChangeDistrict() {
      this.quarters = [];
      this.initiative.quarter_id = null;
      this.getQuarters();
    },
    getInitiative() {
      this.loading = true;
      this.$http
        .get(`api/v1/initiatives/${this.initiativeId}`)
        .then(({ data }) => {
          this.initiative = data;
          this.initiative.granted_amount =
            this.initiative.granted_amount.toString();
          this.initiative.requested_amount =
            this.initiative.requested_amount.toString();
          this.getRegions();
          this.getDistricts();
          this.getQuarters();
        })
        .catch(() => {
          ElNotification({
            title: "Ogohlantirish",
            message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCategories() {
      this.$http
        .get(`api/v1/initiative-categories`)
        .then(({ data }) => {
          this.categories = data.initiative_categories;
        })
        .catch((err) => {
          console.error("category fetch error", err);
        });
    },
    getQuarters() {
      this.$http
        .get(`api/v1/quarters?district_id=${this.initiative.district_id}`)
        .then(({ data }) => {
          this.quarters = data.quarters;
        })
        .catch((err) => {
          console.error("quarters fetch error", err);
        });
    },
    getRegions() {
      this.$http
        .get(`api/v1/regions`)
        .then(({ data }) => {
          this.regions = data.regions;
        })
        .catch((err) => {
          console.error("quarters fetch error", err);
        });
    },
    getDistricts() {
      this.$http
        .get(`api/v1/districts`, {
          params: {
            region_id: this.initiative.region_id,
          },
        })
        .then(({ data }) => {
          this.districts = data.districts;
        })
        .catch((err) => {
          console.error("quarters fetch error", err);
        });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.initiativeId = this.$route.params.id;
      this.getInitiative();
    }
    if (this.$route.query.isModerator) {
      this.isModerator = true;
    }
    this.getCategories();
  },
};
</script>

<style scoped>
.page-wrap {
  padding: 10px;
}
</style>
